import { XMarkIcon } from "@heroicons/react/24/outline";
import { arrayHasItems, formatCurrencyUsdFixedTwo } from "../../../helpers/common";
import { LoaderSpinner } from "../../LoaderSpinner";

export const DraftPoSplitDecisionModal = ({
    isOpen,
    group,
    isLoading = false,
    onCancel,
    onKeepOnePo,
    onSplitPo,
}) => {
    if (!isOpen || !group) return null;

    const skuCount = arrayHasItems(group.variants) ? group.variants.length : 0;
    const cashRequired = formatCurrencyUsdFixedTwo(group.replenishmentCashRequired ?? 0);

    return (
        <div
            aria-hidden="true"
            className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[60] justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full"
        >
            <div
                className="bg-gray-700 top-0 right-0 left-0 fixed z-[60] justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full opacity-30"
                onClick={isLoading ? undefined : onCancel}
            />
            <div className="relative w-full max-w-xl max-h-full bg-white border border-border top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[70] rounded-lg shadow-xl">
                <div className="border-b border-border px-5 py-5">
                    <div className="flex items-start justify-between gap-3">
                        <div>
                            <h2 className="text-lg font-semibold text-primary">Split this PO before Draft?</h2>
                            <p className="mt-1 text-sm text-gray-600">
                                {`${group.groupName || "This product"} will not move into Draft review until you choose whether to split exception SKUs into a separate PO.`}
                            </p>
                        </div>
                        <button
                            type="button"
                            onClick={onCancel}
                            disabled={isLoading}
                            className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-primary hover:bg-gray-800 focus:outline-none disabled:opacity-50"
                        >
                            <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                        </button>
                    </div>
                </div>

                <div className="space-y-4 px-5 py-5">
                    <div className="grid gap-2 text-sm text-gray-600 sm:grid-cols-3">
                        <div className="rounded-md border border-border bg-white px-3 py-3">
                            <p className="text-[11px] uppercase tracking-[0.12em]">Product</p>
                            <p className="mt-1 font-medium text-primary">{group.groupName || "Pending selection"}</p>
                        </div>
                        <div className="rounded-md border border-border bg-white px-3 py-3">
                            <p className="text-[11px] uppercase tracking-[0.12em]">SKUs</p>
                            <p className="mt-1 font-medium text-primary">{skuCount}</p>
                        </div>
                        <div className="rounded-md border border-border bg-white px-3 py-3">
                            <p className="text-[11px] uppercase tracking-[0.12em]">Cash</p>
                            <p className="mt-1 font-medium text-primary">{cashRequired}</p>
                        </div>
                    </div>
                    <div className="rounded-md border border-border bg-background px-4 py-3 text-sm text-gray-600">
                        Choose <span className="font-medium text-primary">Yes, split PO</span> if exception SKUs need separate treatment. Choose <span className="font-medium text-primary">No, keep one PO</span> if this product should move straight into Draft review as a single PO.
                    </div>
                </div>

                <div className="flex flex-col-reverse gap-2 border-t border-border px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={isLoading}
                        className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <div className="flex flex-col-reverse gap-2 sm:flex-row">
                        <button
                            type="button"
                            onClick={onKeepOnePo}
                            disabled={isLoading}
                            className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray" />
                            ) : (
                                "No, keep one PO"
                            )}
                        </button>
                        <button
                            type="button"
                            onClick={onSplitPo}
                            disabled={isLoading}
                            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium shadow-sm text-white bg-primary hover:bg-gray-800 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <LoaderSpinner width="20" height="20" border="3" colorSpinner="white" />
                            ) : (
                                "Yes, split PO"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
